import type { Choice } from "@memorang/types";
import { useDevice } from "../../../../useDevice";
import Box from "../../../Box";
import DragDropBlanks from "../DragDropBlanks";
import { ItemInstruction } from "./pte/ItemInstruction";

type Props = {
	instruction: string;
	stem: string;
	wordBank: Choice[];
	values: Record<string, string>;
	onChangeValues: (values: Record<string, string>) => void;
	disabled?: boolean;
	isAnswered?: boolean;
	inReviewMode?: boolean;
	correctWordIdsByBlank?: Record<string, string>;
};

const FillInTheBlanksDragAndDrop = ({
	instruction,
	stem,
	wordBank,
	values,
	onChangeValues,
	disabled,
	isAnswered,
	inReviewMode,
	correctWordIdsByBlank,
}: Props) => {
	const { isMobile } = useDevice();
	return (
		<Box gap={isMobile ? 16 : 24}>
			<ItemInstruction instruction={instruction} />
			<DragDropBlanks
				stemText={stem}
				wordBank={wordBank}
				values={values}
				onChangeValues={onChangeValues}
				disabled={disabled}
				isAnswered={isAnswered}
				inReviewMode={inReviewMode}
				correctWordIdsByBlank={correctWordIdsByBlank}
				hidePlaceholder
			/>
		</Box>
	);
};

export default FillInTheBlanksDragAndDrop;
